import { render } from "./BenefitsSectionXxl.vue?vue&type=template&id=26b388c7&scoped=true"
import script from "./BenefitsSectionXxl.vue?vue&type=script&lang=js"
export * from "./BenefitsSectionXxl.vue?vue&type=script&lang=js"

import "./BenefitsSectionXxl.vue?vue&type=style&index=0&id=26b388c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b388c7"]])

export default __exports__